import { render } from "./Calculate.vue?vue&type=template&id=6aa1d3f3"
import script from "./Calculate.vue?vue&type=script&lang=js"
export * from "./Calculate.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Projects/opm/yuzhangmen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__